import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c651170"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay_success" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"thanks\" data-v-3c651170><div class=\"hook\" data-v-3c651170></div><div data-v-3c651170><p class=\"text text_success\" data-v-3c651170>支付成功</p><p class=\"text text_thanks\" data-v-3c651170>感谢您的购买</p></div></div><div class=\"message\" data-v-3c651170><div class=\"message_text_container\" data-v-3c651170><p class=\"message_text\" data-v-3c651170>您可从电脑端访问：<span class=\"yellow\" data-v-3c651170>o.keniu.com</span></p><p class=\"message_text\" data-v-3c651170>享受<span class=\"yellow\" data-v-3c651170>办公模板</span>和<span class=\"yellow\" data-v-3c651170>PDF转换</span>权益</p></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
      })
    ])
  ]))
}